<ngx-sonner-toaster richColors/>
<ngx-ui-loader></ngx-ui-loader>
<router-outlet #mainrouter></router-outlet>
